var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.dtCanRender
    ? _c(
        "div",
        { staticClass: "chat-container" },
        [
          _vm.currentTicket
            ? _c("chat-header", {
                attrs: {
                  ticket: _vm.currentTicket,
                  attachments: _vm.conversationAttachments,
                  ticketMembers: _vm.coTicketMembers,
                  "user-id": _vm.userInfo.id,
                  participants: _vm.coParticipant
                },
                on: {
                  reopen: _vm.handleReopenTicket,
                  duplicate: _vm.handleDuplicateTicket,
                  update: _vm.handleUpdateTicket,
                  remove: _vm.handleRemoveParticipant
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-container",
            { staticClass: "pa-0 ma-0", staticStyle: { "min-width": "100%" } },
            [
              _c("chat-content", {
                ref: "message-container",
                attrs: {
                  source: _vm.coActions,
                  "ticket-date": _vm.currentTicket.createdAt,
                  news: _vm.dtMessages,
                  "files-uploading": _vm.dtTemporaryMessages,
                  "is-owner": _vm.coIsOwner
                },
                on: {
                  resend: _vm.handleResendMessage,
                  "open-modal": _vm.handleOpenModal
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.coChannelClosed
            ? _c("v-flex")
            : _vm.coIsOwner && !_vm.coCanJoinChannel
            ? _c("chat-editor", {
                attrs: {
                  "request-modal": _vm.dtRequestModal,
                  "has-contractor": _vm.coHasContractor,
                  "ticket-state": _vm.currentTicket.state
                },
                on: {
                  "update:requestModal": function($event) {
                    _vm.dtRequestModal = $event
                  },
                  "send-file": _vm.handleSendDocument,
                  send: _vm.handleSendMessage
                }
              })
            : _vm.coCanJoinTicket
            ? _c(
                "v-btn",
                {
                  staticStyle: {
                    height: "100%",
                    "min-height": "75px",
                    "border-radius": "5px"
                  },
                  attrs: {
                    color: "primary",
                    loading: _vm.dtRequestLoading,
                    block: ""
                  },
                  on: { click: _vm.handleJoinTicket }
                },
                [
                  _c("v-icon", [_vm._v("person_add")]),
                  _vm._v(
                    "\n    " +
                      _vm._s(_vm.$t(_vm.lblSetting.ticketRequestToJoin)) +
                      "\n  "
                  )
                ],
                1
              )
            : _vm.coCanJoinChannel
            ? _c(
                "v-btn",
                {
                  staticStyle: {
                    height: "100%",
                    "min-height": "75px",
                    "border-radius": "5px"
                  },
                  attrs: {
                    color: "primary",
                    loading: _vm.dtRequestLoading,
                    block: ""
                  },
                  on: { click: _vm.handleJoinChannel }
                },
                [
                  _c("v-icon", [_vm._v("person_add")]),
                  _vm._v(
                    "\n    " +
                      _vm._s(
                        _vm.$t(_vm.lblSetting.ticketRequestToJoinChannel)
                      ) +
                      "\n  "
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.canAskAppointment && _vm.isAskAppointment
            ? _c(
                "v-dialog",
                {
                  attrs: {
                    persistent: "",
                    "content-class": "v-modal-notification",
                    "max-width": "400"
                  },
                  model: {
                    value: _vm.dtRequestModal.visible,
                    callback: function($$v) {
                      _vm.$set(_vm.dtRequestModal, "visible", $$v)
                    },
                    expression: "dtRequestModal.visible"
                  }
                },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "headline primary--text" },
                    [_vm._v(_vm._s(_vm.$t(_vm.dtRequestModal.translationKey)))]
                  ),
                  _vm._v(" "),
                  _c("v-card-text", { staticClass: "py-0  primary--text" }, [
                    _vm._v(_vm._s(_vm.$t(_vm.lblSetting.ticketAppointmentDesc)))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "px-3" },
                    [
                      _c("base-datetime-picker-range", {
                        attrs: { is24h: true },
                        model: {
                          value: _vm.dtDate,
                          callback: function($$v) {
                            _vm.dtDate = $$v
                          },
                          expression: "dtDate"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary darken-1", flat: "" },
                          nativeOn: {
                            click: function($event) {
                              _vm.dtRequestModal.visible = false
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("BTN_CANCEL")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary darken-1", flat: "" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.handleRecord($event)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("BTN_RECORD")))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _c(
                "base-modal-duplicate",
                {
                  ref: "modal",
                  attrs: {
                    color: "backgroundGrey",
                    icon: _vm.coIcon,
                    "icon-type": "icon",
                    "max-width": _vm.maxWidth,
                    title: _vm.isClose
                      ? _vm.$t(_vm.lblSetting.ticketCloseTicketTitle)
                      : _vm.$t(_vm.dtRequestModal.translationKey),
                    "before-close": _vm.handleBeforeClose,
                    "submit-btn-title": _vm.$t(_vm.lblSetting.btnValidate),
                    "action-position": _vm.isAskQuote ? null : "center",
                    loading: _vm.buttonLoading
                  },
                  on: { onRecord: _vm.handleRecord },
                  model: {
                    value: _vm.dtRequestModal.visible,
                    callback: function($$v) {
                      _vm.$set(_vm.dtRequestModal, "visible", $$v)
                    },
                    expression: "dtRequestModal.visible"
                  }
                },
                [
                  _vm.isCreateAppointment
                    ? [
                        _c(
                          "chat-agenda-modal",
                          {
                            attrs: {
                              self: false,
                              "contractors-source": _vm.coContractorsSource,
                              "ticket-name": _vm.coTicketName,
                              "ticket-description": _vm.coTicketDescription,
                              "ticket-block": _vm.coTicketBlock.id
                            },
                            on: { fieldUpdate: _vm.onAppointmentFieldUpdate }
                          },
                          [
                            _c("chat-agenda", {
                              attrs: {
                                "block-info": _vm.coTicketBlock,
                                ics: _vm.coContractorsSource,
                                udpateAppointmentField:
                                  _vm.dtUpdateAppointmentField
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass:
                              "ml-3 mr-3 chat-container__redirect-to-agenda ",
                            attrs: {
                              slot: "action-left",
                              to: { path: "/agenda" }
                            },
                            slot: "action-left"
                          },
                          [
                            _vm._v(
                              "\n        " +
                                _vm._s(_vm.$t(_vm.lblSetting.ticketGotoAgenda))
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "template",
                          { slot: "action-between" },
                          [
                            _vm.isCreating
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      flat: "",
                                      color: "primary",
                                      loading: _vm.dtWithoutValidateIsLoading
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.handleSaveWithoutValidate(
                                          $event
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(
                                          _vm.$t(
                                            _vm.lblSetting
                                              .btnSaveWithoutValidate
                                          )
                                        ) +
                                        "\n        "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    : _vm.isAttachDocument
                    ? _c("document-modal-vertical", {
                        attrs: { isTicketChat: "" }
                      })
                    : _vm.isMandateSpeaker
                    ? _c("chat-mandate-speaker-modal", {
                        attrs: { "text-key": "service_order" },
                        model: {
                          value: _vm.dtMandateRequestPayload,
                          callback: function($$v) {
                            _vm.dtMandateRequestPayload = $$v
                          },
                          expression: "dtMandateRequestPayload"
                        }
                      })
                    : _vm.isAskQuote
                    ? _c("chat-mandate-speaker-modal", {
                        attrs: { "text-key": "quote_request_text" },
                        model: {
                          value: _vm.dtQuoteRequestPayload,
                          callback: function($$v) {
                            _vm.dtQuoteRequestPayload = $$v
                          },
                          expression: "dtQuoteRequestPayload"
                        }
                      })
                    : _vm.isClose
                    ? [
                        _c(
                          "v-layout",
                          { attrs: { column: "", "px-3": "" } },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text-xs-center primary--text py-3"
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(_vm.lblSetting.ticketCloseTicket)
                                    )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "base-control-label",
                              {
                                attrs: {
                                  required: "",
                                  label: _vm.$t(
                                    _vm.lblSetting.ticketClosureReason
                                  )
                                }
                              },
                              [
                                _c("v-select", {
                                  attrs: {
                                    "single-line": false,
                                    rules: _vm.dtClosureReasonRules,
                                    items: _vm.coClosureReasons,
                                    color: "primary",
                                    "item-value": "id",
                                    "item-text": "name",
                                    "return-object": true,
                                    solo: "",
                                    placeholder: _vm.$t(
                                      _vm.lblSetting
                                        .ticketClosureReasonPlacehodler
                                    )
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "item",
                                      fn: function(data) {
                                        return [
                                          _c(
                                            "v-layout",
                                            { attrs: { column: "", wrap: "" } },
                                            [
                                              _c(
                                                "strong",
                                                {
                                                  staticClass: "full-width",
                                                  attrs: { for: "" }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(data.item.name) +
                                                      _vm._s("\n")
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "chat-container__description--text"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      data.item.description
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ]),
                                  model: {
                                    value: _vm.dtClosureReason,
                                    callback: function($$v) {
                                      _vm.dtClosureReason = $$v
                                    },
                                    expression: "dtClosureReason"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.coTicketsReasons.length > 0
                              ? _c(
                                  "base-control-label",
                                  {
                                    attrs: {
                                      label: _vm.$t(_vm.lblSetting.ticketReason)
                                    }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        "single-line": false,
                                        rules: [],
                                        items: _vm.coTicketsReasons,
                                        color: "primary",
                                        "item-value": "id",
                                        "item-text": "name",
                                        "return-object": true,
                                        solo: "",
                                        placeholder: _vm.$t(
                                          _vm.lblSetting.ticketReasonPlacehodler
                                        )
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "item",
                                          fn: function(data) {
                                            return [
                                              _c(
                                                "v-layout",
                                                {
                                                  attrs: {
                                                    column: "",
                                                    wrap: ""
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "strong",
                                                    {
                                                      staticClass: "full-width",
                                                      attrs: { for: "" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(data.item.name) +
                                                          _vm._s("\n")
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ]),
                                      model: {
                                        value: _vm.dtTicketReason,
                                        callback: function($$v) {
                                          _vm.dtTicketReason = $$v
                                        },
                                        expression: "dtTicketReason"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "base-control-label",
                              {
                                attrs: {
                                  label: _vm.$t(
                                    _vm.lblSetting
                                      .ticketClosureReasonDescription
                                  )
                                }
                              },
                              [
                                _c("v-textarea", {
                                  staticClass: "white",
                                  attrs: { "auto-grow": "", solo: "", rows: 3 },
                                  model: {
                                    value: _vm.dtClosureReasonDescription,
                                    callback: function($$v) {
                                      _vm.dtClosureReasonDescription = $$v
                                    },
                                    expression: "dtClosureReasonDescription"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    : _vm.isGenerateInterventionReport
                    ? _c("chat-intervention-report-modal", {
                        model: {
                          value: _vm.dtTicketInterventionReport,
                          callback: function($$v) {
                            _vm.dtTicketInterventionReport = $$v
                          },
                          expression: "dtTicketInterventionReport"
                        }
                      })
                    : _vm.dtConfirmModalVisible
                    ? [
                        _c("base-control-label", {
                          attrs: {
                            label:
                              _vm.dtConfirm.action_type === "message"
                                ? _vm.$t(_vm.lblSetting.ticketMessageDelete)
                                : _vm.$t(_vm.lblSetting.ticketAttachmentDelete)
                          }
                        }),
                        _vm._v(" "),
                        _c("v-card-text", {
                          domProps: { innerHTML: _vm._s(_vm.dtConfirm.text) }
                        })
                      ]
                    : _vm._e()
                ],
                2
              ),
          _vm._v(" "),
          _vm.dtErrorModalVisible
            ? _c("base-error-dialog", {
                attrs: { error: _vm.dtError },
                on: { cancel: _vm.handleRemoveError }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.dtDetailErrorModalVisible
            ? _c("base-error-dialog", {
                attrs: { error: _vm.dtDetailError },
                on: { cancel: _vm.handleGoBack }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0adcd410", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0adcd410","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/ticket-child-chat/template.html
// module id = null
// module chunks = 